import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
window.location.href = process.env.VUE_APP_REDIRECT_TO_BYPASS;
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/thankyou',
    name: 'Thankyou',
    component: () => import('../views/Thankyou.vue'),
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
